// constants
import { SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/scrollmagic/controller';

// assets
import './scrollToTop.scss';

export function scrollToTopScene() {
  const scrollToTop = document.createElement('div');
  const content = document.querySelector('.body-wrapper');
  if (!content) return false;

  scrollToTop.className = 'scroll-to-top';
  scrollToTop.dataset.role = 'scroll-to-top';
  document.body.appendChild(scrollToTop);
  scrollToTop.addEventListener('click', () => {
    $('html, body').stop().animate({ scrollTop: 0 });
  });

  const scene = new ScrollMagic.Scene({
    triggerElement: content,
    triggerHook: 'onLeave',
  })
    .setClassToggle(scrollToTop, SELECTORS.active)
    // .addIndicators({ name: 'Scroll to top' })
    .addTo(controller);

  return {
    destroy() {
      scrollToTop.remove();
      scene.destroy();
    },
  };
}
